import {createContext, ReactNode, useEffect, useState} from "react";
import firebase from "firebase/compat/app";
import 'firebase/compat/auth'
import axios from "axios";
import {APIurl} from "./Utils";


export const AuthContext = createContext<any>(null);

interface AuthProviderProps {
    children?: ReactNode
}

export enum AUTHSTATES {
    UNKNOWN,
    LOGGEDIN,
    LOGGEDOUT,
}

export function AuthProvider(props: AuthProviderProps) {

    const [authState, setAuthState] = useState<AUTHSTATES>(AUTHSTATES.UNKNOWN);
    const [currentUser, setCurrentUser] = useState<any>(null);

    useEffect(() => {
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                const isAdmin = await checkIfAdmin(user)
                if(isAdmin) {
                    setCurrentUser(user)
                    setAuthState(AUTHSTATES.LOGGEDIN)
                } else {
                    setCurrentUser(null)
                    setAuthState(AUTHSTATES.LOGGEDOUT)
                    firebase.auth().signOut().then(() => {})
                }
            } else {
                setCurrentUser(null)
                setAuthState(AUTHSTATES.LOGGEDOUT)
                firebase.auth().signOut().then(() => {})
            }
        })
    }, [])

    return (
        <AuthContext.Provider value={{currentUser, authState}}>
            {props.children}
        </AuthContext.Provider>
    )
}

export const checkIfAdmin = async (user: firebase.User): Promise<boolean> => {
    try {
        const uid = user.uid
        const token = await user.getIdToken()
        const response = await axios.get<{ isAdmin: boolean }>(`${APIurl}/isAdmin/${uid}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data.isAdmin;
    } catch (error) {
        console.error("Errore durante la verifica dell'admin:", error);
        return false;
    }
};